/* src/app/main/declaration-reports/shared-debtor-by-policy/shared-debtor-by-policy-parameters.component.scss */
/*# sourceMappingURL=shared-debtor-by-policy-parameters.component-MBNSEDC4.css.map */
